






















































































import {
	computed,
	defineComponent,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import SelectBox from '@front-app/components/inputs/SelectBox.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { Routes } from '@front-app/constants/routes';
import { PageProgress } from '@front-app/store/singletons/PageProgress';
import { SearchType } from '@front-app/services/SearchApi/SearchModel';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import { SearchResult, SearchResultType } from '@front-app/services/SearchApi/SearchApi';
import { useContentSearch } from '@front-app/hooks/useContentSearch';
import HeaderNav from './HeaderNav.vue';
import SearchBox from '../search/SearchBox.vue';
import SearchResultComponent from '../search/SearchResult.vue';
import SearchPlaceholder from '../search/SearchPlaceholder.vue';
import ProgressBar from './ProgressBar.vue';
import CurrentUserMenu from './CurrentUserMenu.vue';
import { useRollingIndex } from '../search/useRollingIndex';
import { SearchOption } from '../search/useSearch';

const SEARCH_TYPE_OPTIONS: SearchType[] = [
	SearchType.FULL,
	SearchType.NETWORK,
];

const SEARCH_TYPE_OPTION_LABELS: Record<SearchType, string> = {
	[SearchType.FULL]: 'All Network',
	[SearchType.NETWORK]: 'My Network',
};

export default defineComponent({
	components: {
		HeaderNav,
		SearchBox,
		SearchResultComponent,
		SearchPlaceholder,
		CurrentUserMenu,
		ProgressBar,
		SelectBox,
	},
	setup(props, ctx) {
		// Search type
		const groupsStore = GroupsStore.getInstance();
		const searchTypes: Ref<SelectBoxChoice[]> = computed(() => SEARCH_TYPE_OPTIONS
			.map((option) => ({
				key: option,
				label: ctx.root.$t(SEARCH_TYPE_OPTION_LABELS[option]) as unknown as string,
			})));
		const selectedSearchType: Ref<SearchType> = ref(SearchType.FULL);
		const selectedSearchTypeLabel = computed(() => ctx.root.$t(SEARCH_TYPE_OPTION_LABELS[selectedSearchType.value]));
		const selectSearchType = (option: SearchType) => {
			selectedSearchType.value = option;
		};
		// Set the selected search type to 'All Network' if the number of user groups is more than 2
		watch(() => groupsStore.groups.value.length, (curr, prev) => {
			if (curr !== prev && curr > 2 && selectedSearchType.value !== SearchType.NETWORK) {
				selectedSearchType.value = SearchType.NETWORK;
			}
		});

		const isSearchLoading = ref(true);
		const searchValue = ref('');
		const allSearchResults = ref([] as SearchOption<SearchResult>[]);
		async function searchContent(searchString: string) {
			isSearchLoading.value = true;
			allSearchResults.value = await useContentSearch(selectedSearchType.value, SearchResultType.ANY, searchString);
			isSearchLoading.value = false;
		}

		const searchFocus = useRollingIndex(allSearchResults);
		const focusedSearchIdx = searchFocus.selectedIdx;
		const focusNextSearchResult = searchFocus.next;
		const focusPrevSearchResult = searchFocus.prev;
		const clearSearch = () => {
			focusedSearchIdx.value = null;
			searchValue.value = '';
		};

		const openFirstSearchResult = () => {
			if (allSearchResults.value.length === 0) {
				return;
			}
			const firstResult = allSearchResults.value[0].url;
			if ((typeof firstResult === 'string')) {
				window.open(firstResult, '_blank');
			} else {
				ctx.root.$router.push(firstResult);
			}
			clearSearch();
		};

		return {
			Routes: {
				GROUP_ADMIN_DATA: Routes.GROUP_ADMIN_DATA,
			},
			clearSearch,
			focusedSearchIdx,
			focusNextSearchResult,
			focusPrevSearchResult,
			searchValue,
			allSearchResults,
			searchContent,
			openFirstSearchResult,
			isSearchLoading,
			hoveredItem: ref(null),
			pageProgress: PageProgress.progress,
			// Search type
			searchTypes,
			selectedSearchType,
			selectedSearchTypeLabel,
			selectSearchType,
		};
	},
});
